export enum BlockState {
  Enabled = 'enabled',
  Disabled = 'disabled',
}
